import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IOwnerObject } from "../../../../services/api.types";

// Phase 26 — Status tri-state (D-10/D-11). "Pending review" takes display
// precedence over Busy/Online/Offline; Busy (on a wash, availabilityStatus) shows
// instead of Online; Online when isOnline (2-min heartbeat);
// else Offline. `hasPendingReview` is a boolean flag, not a count — do not
// repoint this at pendingReviewCount.
export default function StatusChip({ item }: { item: IOwnerObject }) {
  const { t } = useTranslation();
  if (item.hasPendingReview) {
    return <Chip label={t("status.pendingReview")} color="warning" size="small" />;
  }
  if (item.availabilityStatus === "busy") {
    return <Chip label={t("status.busy")} color="warning" size="small" />;
  }
  if (item.isOnline) {
    return <Chip label={t("status.online")} color="success" size="small" />;
  }
  return <Chip label={t("status.offline")} color="default" size="small" />;
}
